import React from "react";
import { Alert, Box, Card, CardActionArea, CircularProgress, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CreateButton, StandardPageHeader } from "app/shared/ui";
import { getReportType } from "./types";
import useReportCatalog from "./useReportCatalog";
import ReportTemplatesList from "./templates/ReportTemplatesList";

// Pestañas de «Reportes»: las plantillas guardadas (se generan eligiendo solo las fechas) y el reporte rápido, que se
// arma completo cada vez y se puede guardar como plantilla.
const ReportsHome = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const catalog = useReportCatalog();
    const tab = searchParams.get("tab") === "quick" ? "quick" : "templates";

    const { types, stores } = catalog;
    const selectedKey = searchParams.get("type") || (types.length === 1 ? types[0].key : null);
    const selected = types.find((type) => type.key === selectedKey);
    const definition = selected && getReportType(selected.key);

    const newTemplate = () => navigate("/automations/reports/templates/new", {
        state: { draft: { report_type: types.length === 1 ? types[0].key : selectedKey }, from: "/automations/reports" },
    });

    return (
        <Box>
            <StandardPageHeader
                title="Reportes"
                subtitle="Resúmenes de tus mediciones para imprimir y presentar, por ejemplo en una fiscalización del ISP o la Seremi."
                actions={tab === "templates" && !!types.length && <CreateButton onClick={newTemplate}>Nueva plantilla</CreateButton>}
            />
            <Tabs value={tab} onChange={(event, value) => setSearchParams(value === "quick" ? { tab: "quick" } : {})} sx={{ mb: 2 }}>
                <Tab value="templates" label="Plantillas" />
                <Tab value="quick" label="Reporte rápido" />
            </Tabs>

            {catalog.loading && <Box sx={{ py: 6, textAlign: "center" }}><CircularProgress /></Box>}
            {!!catalog.error && <Alert severity="error">{catalog.error}</Alert>}

            {!catalog.loading && !catalog.error && tab === "templates" && (
                <ReportTemplatesList stores={stores} onCreate={newTemplate} onQuickReport={() => setSearchParams({ tab: "quick" })} />
            )}

            {!catalog.loading && tab === "quick" && (
                <>
                    {types.length > 1 && (
                        <Grid container spacing={1.5} sx={{ mb: 2 }}>
                            {types.map((type) => {
                                const Icon = getReportType(type.key)?.icon || AssessmentOutlinedIcon;
                                return (
                                    <Grid item xs={12} md={6} lg={4} key={type.key}>
                                        <Card variant="outlined" sx={{ borderRadius: 2.5, borderColor: type.key === selectedKey ? "primary.main" : undefined }}>
                                            <CardActionArea sx={{ p: 2 }} onClick={() => setSearchParams({ tab: "quick", type: type.key })}>
                                                <Stack direction="row" spacing={1.5} alignItems="center">
                                                    <Icon color="primary" />
                                                    <Box>
                                                        <Typography variant="body1" fontWeight={600}>{type.title}</Typography>
                                                        <Typography variant="caption" color="text.secondary">{type.description}</Typography>
                                                    </Box>
                                                </Stack>
                                            </CardActionArea>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                    {selected && definition && <definition.Component type={selected} stores={stores} />}
                    {selected && !definition && <Alert severity="warning">Este reporte no está disponible en esta versión de la aplicación.</Alert>}
                </>
            )}
        </Box>
    );
};

export default ReportsHome;
